import React, { useState } from "react";
import ButtonComponent from "../elements/ButtonComponent";
import ContactSupport from "../ContactSupport/ContactSupport";
import { motion } from "framer-motion";
import { childVariants } from "../../animation/RoutesAnimations";
import Lottie from "react-lottie";
import animationData from "../../../src/jsons/LoadingBg.json";
import PendorVerifyModal from "./PendorVerifyModal";
import VideoModal from "./VideoModal";
import { useNavigate } from "react-router-dom";

interface ConfirmInfoProps {
  newShowModalState?: boolean;
  onBack?: any;
  formNo?: any;
  setFormNo?: any;
  setIsLoadingContents?: any;
  storeStateConfirmInfo?: any;
  storeState?: any;
}

const ConfirmInfo: React.FC<ConfirmInfoProps> = ({
  onBack,
  setFormNo,
  formNo,
  storeStateConfirmInfo,
  storeState,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [openVideo, setOpenVideo] = useState(false);
  const handleShowModalChange = (newShowModalState: boolean) => {
    setShowModal(newShowModalState);
  };

  const confirmtoContinue = () => {
    setFormNo(formNo + 1);
  };

  const handleButtonClick = () => {
    setOpenVideo(!openVideo);
  };

  const navigate = useNavigate();

  let content;
  switch (storeState) {
    case "PEND_FOR_VERIFY":
      content = (
        <div>
          <div className="w-[298px] lg:w-[432px] h-[214px] lg:h-[287px] border border-yellow-300 rounded-lg flex flex-col items-center justify-center gap-4">
            <div className="bg-yellow-100 w-[80px] lg:w-[124px] h-[80px] lg:h-[124px] rounded-full flex items-center justify-center ">
              <img
                src="/icons/clock-outline.svg"
                alt="check status"
                className="w-[51px] lg:w-[80px] h-[51px] lg:h-[80px] "
              ></img>
            </div>
            <div className="text-yellow-400 w-[244px] h-[40px]  text-center text-Title/16/Bold lg:text-HeadLine/24/Bold ">
              در انتظار تایید سوپروایزر
            </div>
            <div className="  text-gray-400 text-Body-OneLine/12/Medium  lg:text-Body-OneLine/14/Medium">
              لطفا منتظر بمانید
            </div>
          </div>
          <div className={`mt-[20px] mr-[30px] lg:mr-[96px] text-[14px] `}>
            <ButtonComponent
              onClick={handleButtonClick}
              variant="filled"
              hasIcon
              icon={
                <img
                  src="/icons/clapperboard-play-outline.svg"
                  alt="icon play video"
                  className="bg-white"
                />
              }
            >
              مشاهده ویدیو آموزش سامانه
            </ButtonComponent>
          </div>
          <div
            id="idModalCall"
            className={`fixed my-auto mx-auto z-50 flex inset-0 justify-center items-center  ${
              showModal
                ? "visible h-screen w-full bg-opacity-25 backdrop-blur-sm"
                : "hidden"
            }`}
          >
            {showModal ? (
              <>
                <PendorVerifyModal
                  onShowModalChange={handleShowModalChange}
                  telNumber={45313}
                />
              </>
            ) : openVideo ? (
              <>
                <VideoModal
                  onShowModalChange={handleButtonClick}
                  telNumber={45313}
                />
              </>
            ) : null}
          </div>
          <div className="mt-[20px] gap-3 flex flex-col items-center justify-center">
            <ButtonComponent
              variant="outlined"
              onClick={() => setShowModal(true)}
              className="text-Body-OneLine/14/Medium"
            >
              تماس با پشتیبانی
            </ButtonComponent>
            <ButtonComponent
              onClick={() => navigate("/")}
              className="text-Body-OneLine/14/Medium"
            >
              بازگشت به خانه
            </ButtonComponent>
          </div>
          <div
            id="default-modal"
            aria-hidden="true"
            className="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full"
          ></div>
          <div className="flex absolute  left-[7%] md:left-[25%] lg:left-0 lg:mx-0 lg:mt-0 mt-[70px]">
            <ButtonComponent
              variant="outlined"
              // disabled
              className="w-[120px] h-[40px] mx-2"
              onClick={onBack}
            >
              بازگشت
            </ButtonComponent>
            <ButtonComponent
              type="button"
              variant="filled"
              disabled
              className="w-[120px] h-[40px]"
            >
              ادامه
            </ButtonComponent>
          </div>
        </div>
      );
      break;
    case "VERIFIED":
      content = (
        <div>
          <div className="w-[298px] lg:w-[432px] h-[214px] lg:h-[287px] border border-green-300 rounded-lg flex flex-col items-center justify-center gap-6">
            <div className="bg-green-100 w-[80px] lg:w-[124px] h-[80px] lg:h-[124px] rounded-full flex items-center justify-center ">
              <img
                src="/icons/check-outline.svg"
                alt="check status"
                className="w-12 lg:w-24 h-12 lg:h-24"
              ></img>
            </div>
            <div className="text-green-600 text-HeadLine/24/Bold mb-2 text-center">
              اطلاعات شما با موفقیت
              <br /> تایید شد
            </div>
          </div>
          <div className="flex absolute m-2 left-[20%] md:left-[23%] lg:left-14 mt-[70px] lg:mt-[100px]">
            <ButtonComponent
              variant="outlined"
              disabled
              className="w-20 md:w-32 h-12 mx-2"
              onClick={onBack}
            >
              بازگشت
            </ButtonComponent>
            <ButtonComponent
              variant="filled"
              type="submit"
              className="w-20 md:w-32 h-12"
              onClick={confirmtoContinue}
            >
              ادامه
            </ButtonComponent>
          </div>
        </div>
      );
      break;
    case "PAID":
      content = (
        <div>
          <div className="w-[298px] lg:w-[432px] h-[214px] lg:h-[287px] border border-green-300 rounded-lg flex flex-col items-center justify-center gap-6">
            <div className="bg-green-100 w-[80px] lg:w-[124px] h-[80px] lg:h-[124px] rounded-full flex items-center justify-center ">
              <img
                src="/icons/check-outline.svg"
                alt="check status"
                className="w-12 lg:w-24 h-12 lg:h-24"
              ></img>
            </div>
            <div className="text-green-600 text-HeadLine/24/Bold mb-2 text-center">
              اطلاعات شما با موفقیت
              <br /> تایید شد
            </div>
          </div>
          <div className="flex absolute m-2 left-[20%] md:left-[23%] lg:left-14 mt-[70px] lg:mt-[100px]">
            <ButtonComponent
              variant="outlined"
              disabled
              className="w-20 md:w-32 h-12 mx-2"
              onClick={onBack}
            >
              بازگشت
            </ButtonComponent>
            <ButtonComponent
              variant="filled"
              type="submit"
              className="w-20 md:w-32 h-12"
              onClick={confirmtoContinue}
            >
              ادامه
            </ButtonComponent>
          </div>
        </div>
      );
      break;
    case "REJECTED":
      content = (
        <div>
          <div className="w-[298px] lg:w-[432px] h-[214px] lg:h-[287px] border border-red-300 rounded-lg flex flex-col items-center justify-center gap-6">
            <div className="bg-red-100 w-[80px] lg:w-[124px] h-[80px] lg:h-[124px] rounded-full flex items-center justify-center ">
              <img
                src="/icons/x-outline.svg"
                alt="check status"
                className="w-[51px] lg:w-[80px] h-[51px] lg:h-[80px] "
              ></img>
            </div>
            <div className="text-red-600 w-[244px] h-[40px] text-Title/16/Bold lg:text-HeadLine/24/Bold text-center">
              فروشگاه شما تایید نشد.
            </div>
          </div>
          <div
            id="idModalCall"
            className={`fixed my-auto mx-auto z-50 flex inset-0 justify-center items-center  ${
              showModal ? "visible bg-opacity-25 backdrop-blur-sm" : "hidden"
            }`}
          >
            {showModal ? (
              <>
                <ContactSupport
                  onShowModalChange={handleShowModalChange}
                  telNumber={45313}
                />
              </>
            ) : null}
          </div>
          <div className=" flex flex-1 justify-center items-center mt-5 lg:text-Title/16/Bold">
            <ButtonComponent
              variant="outlined"
              onClick={() => setShowModal(true)}
            >
              تماس با پشتیبانی
            </ButtonComponent>
          </div>
          <div className="flex absolute left-[8%] md:left-[25%] lg:left-0 lg:mx-0 mt-[70px] lg:mt-[50px] ">
            <ButtonComponent
              variant="outlined"
              className="w-[120px] h-[40px] ml-2"
              // disabled
              onClick={onBack}
            >
              بازگشت
            </ButtonComponent>
            <ButtonComponent
              variant="filled"
              type="submit"
              disabled
              className="w-[120px] h-[40px]"
            >
              ادامه
            </ButtonComponent>
          </div>
        </div>
      );
      break;
    case "SUSPENDED":
      content = (
        <div>
          <div className="w-[298px] lg:w-[432px] h-[214px] lg:h-[287px] border border-red-300 rounded-lg flex flex-col items-center justify-center gap-6">
            <div className="bg-red-100 w-[80px] lg:w-[124px] h-[80px] lg:h-[124px] rounded-full flex items-center justify-center ">
              <img
                src="/icons/x-outline.svg"
                alt="check status"
                className="w-[51px] lg:w-[80px] h-[51px] lg:h-[80px] "
              ></img>
            </div>
            <div className="text-red-600 w-[244px] h-[40px] text-Title/16/Bold lg:text-HeadLine/24/Bold text-center">
              فروشگاه شما تایید نشد.
            </div>
          </div>
          <div
            id="idModalCall"
            className={`fixed my-auto mx-auto z-50 flex inset-0 justify-center items-center  ${
              showModal ? "visible bg-opacity-25 backdrop-blur-sm" : "hidden"
            }`}
          >
            {showModal ? (
              <>
                <ContactSupport
                  onShowModalChange={handleShowModalChange}
                  telNumber={45313}
                />
              </>
            ) : null}
          </div>
          <div className=" flex flex-1 justify-center items-center mt-5 lg:text-Title/16/Bold">
            <ButtonComponent
              variant="outlined"
              onClick={() => setShowModal(true)}
            >
              تماس با پشتیبانی
            </ButtonComponent>
          </div>
          <div className="flex absolute left-[8%] md:left-[25%] lg:left-0 lg:mx-0 mt-[70px] lg:mt-[50px] ">
            <ButtonComponent
              variant="outlined"
              className="w-[120px] h-[40px] ml-2"
              // disabled
              onClick={onBack}
            >
              بازگشت
            </ButtonComponent>
            <ButtonComponent
              variant="filled"
              type="submit"
              disabled
              className="w-[120px] h-[40px]"
            >
              ادامه
            </ButtonComponent>
          </div>
        </div>
      );
      break;
    default:
      content = (
        <div>
          <div className="w-[298px] lg:w-[432px] h-[214px] lg:h-[287px] border border-yellow-300 rounded-lg flex flex-col items-center justify-center gap-4">
            <div className="bg-yellow-100 w-[80px] lg:w-[124px] h-[80px] lg:h-[124px] rounded-full flex items-center justify-center ">
              <img
                src="/icons/clock-outline.svg"
                alt="check status"
                className="w-[51px] lg:w-[80px] h-[51px] lg:h-[80px] "
              ></img>
            </div>
            <div className="text-yellow-400 w-[244px] h-[40px]  text-center text-Title/16/Bold lg:text-HeadLine/24/Bold ">
              در انتظار تایید سوپروایزر
            </div>
            <div className="  text-gray-400 text-Body-OneLine/12/Medium  lg:text-Body-OneLine/14/Medium">
              لطفا منتظر بمانید
            </div>
          </div>
          <div className={`mt-[20px] mr-[30px] lg:mr-[96px] text-[14px] `}>
            <ButtonComponent
              onClick={handleButtonClick}
              variant="filled"
              hasIcon
              icon={
                <img
                  src="/icons/clapperboard-play-outline.svg"
                  alt="icon play video"
                  className="bg-white"
                />
              }
            >
              مشاهده ویدیو آموزش سامانه
            </ButtonComponent>
          </div>
          <div
            id="idModalCall"
            className={`fixed my-auto mx-auto z-50 flex inset-0 justify-center items-center  ${
              showModal
                ? "visible h-screen w-full bg-opacity-25 backdrop-blur-sm"
                : "hidden"
            }`}
          >
            {showModal ? (
              <>
                <PendorVerifyModal
                  onShowModalChange={handleShowModalChange}
                  telNumber={45313}
                />
              </>
            ) : openVideo ? (
              <>
                <VideoModal
                  onShowModalChange={handleButtonClick}
                  telNumber={45313}
                />
              </>
            ) : null}
          </div>
          <div className="mt-[20px] mr-[70px] lg:mr-[140px] ">
            <ButtonComponent
              variant="outlined"
              onClick={() => setShowModal(true)}
              className="text-Body-OneLine/14/Medium"
            >
              تماس با پشتیبانی
            </ButtonComponent>
          </div>
          <div
            id="default-modal"
            aria-hidden="true"
            className="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full"
          ></div>
          <div className="flex absolute  left-[7%] md:left-[25%] lg:left-0 lg:mx-0 lg:mt-0 mt-[70px]">
            <ButtonComponent
              variant="outlined"
              // disabled
              className="w-[120px] h-[40px] mx-2"
              onClick={onBack}
            >
              بازگشت
            </ButtonComponent>
            <ButtonComponent
              type="button"
              variant="filled"
              disabled
              className="w-[120px] h-[40px]"
            >
              ادامه
            </ButtonComponent>
          </div>
        </div>
      );
  }

  const [isLoadingContents, setIsLoadingContents] = useState<boolean>(false);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    renderer: "svg",
  };

  return (
    <>
      {isLoadingContents ? (
        <>
          <div className="flex  gap-8 basis-3/4 rounded-md md:ml-8 ml-2 shadow-md pb-20">
            <div className=" full-screen">
              <Lottie options={defaultOptions} height={100} width={100} />
            </div>
          </div>
        </>
      ) : (
        <motion.form
          variants={childVariants}
          initial="initial"
          animate="final"
          className="flex flex-1 items-center justify-center rounded-md shadow-md  "
        >
          <div className="md:mt-20 lg:mt-36 ">{content}</div>
        </motion.form>
      )}
    </>
  );
};
export default ConfirmInfo;
